import {
  styled,
  TextTag,
  Text,
  TokenTextAppearance,
  CTA,
  Container,
  ContainerGutter,
  ContainerPadding,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, {useState} from 'react';
import {LayerCloseHandle} from '../../Layers/layers';
import {Checkmark, Close} from '@volkswagen-onehub/icons-core';
import CopyLink from './CopyLink';
import {getTranslations} from '../../translations';

interface ShareListModalInterface {
  close: LayerCloseHandle;
}

const ShareListModalContainer = styled.div`
  padding: ${(props) => props.theme.size.dynamic0040};
`;

const ShareListClose = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

const ShareListFooter = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0020};
  font-weight: bold;
`;

const CopiedLinkContainer = styled.div`
  color: #0f852f;
`;

const ShareListModal: React.FC<ShareListModalInterface> = ({close}) => {
  const { aria, labels } = getTranslations();
  const [showCopyLink, setShowCopyLink] = useState<boolean>(false);

  return (
    <ShareListModalContainer>
      <ShareListClose>
        <CTA
          ariaLabel={aria.close}
          onClick={() => close()}
          tag="button"
          emphasis="tertiary"
          icon={<Close ariaHidden />}
        />
      </ShareListClose>
      <Container
        wrap="always"
        gutter={ContainerGutter.dynamic0100}
        padding={{
          top: ContainerPadding.dynamic0040,
          left: ContainerPadding.grid001,
          right: ContainerPadding.grid001,
          bottom: ContainerPadding.grid001,
        }}
      >
        <Text
          tag={TextTag.h4}
          bold
          appearance={TokenTextAppearance.headline300}
        >
          {labels.share.title.modal}
        </Text>
        <Text tag={TextTag.p}>{labels.share.copy.modal}</Text>
        <ShareListFooter>
          <CopyLink
            onShowCopyLink={setShowCopyLink}
            copy={labels.share.linkCopy}
          />

          {showCopyLink && (
            <CopiedLinkContainer role="alert" aria-live="assertive">
              <Checkmark ariaHidden variant="small" />
              &nbsp;
              <Text
                tag={TextTag.span}
                appearance={TokenTextAppearance.label100}
                color={TokenTextColor.inherit}
              >
                {labels.share.linkCopied}
              </Text>
            </CopiedLinkContainer>
          )}
        </ShareListFooter>
      </Container>
    </ShareListModalContainer>
  );
};

export default ShareListModal;
